import styled from 'styled-components';

import { COLORS } from 'styles/constants';

interface ContainerProps {
  hasContactInfo: boolean;
}

export const Container = styled.button<ContainerProps>`
  margin: 20px;
  padding: 20px 25px 15px 25px;
  width: 20%;

  position: relative;

  color: #808080;
  text-decoration: none;
  text-align: center;
  background: #fff;
  border-radius: 4px;
  border: none;
  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);
  transition: background 0.2s;

  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  &:hover {
    text-decoration: none;
    background: #ddd;
  }

  @media only screen and (max-width: 700px) {
    width: 90%;
  }

  @media all and (min-width: 600px) and (max-width: 1200px) {
    /* tablet, landscape iPad, lo-res laptops ands desktops */
    font-size: 25px;
    width: 40%;
  }
`;

export const Ribbon = styled.div`
  width: 150px;
  height: 150px;
  overflow: hidden;
  position: absolute;

  &::before,
  &::after {
    position: absolute;
    z-index: -1;
    content: '';
    display: block;
    border: 5px solid ${COLORS.primary};
  }

  span {
    position: absolute;
    display: block;
    width: 225px;
    padding: 15px 0;
    background-color: ${COLORS.primary};
    box-shadow: 0 5px 10px rgba(0, 0, 0, 0.1);
    color: #fff;
    font: 700 16px/1 'Lato', sans-serif;
    text-shadow: 0 1px 1px rgba(0, 0, 0, 0.2);
    text-align: center;
  }

  top: -10px;
  right: -10px;

  &::before,
  &::after {
    border-top-color: transparent;
    border-right-color: transparent;
  }
  &::before {
    top: 0;
    left: 0;
  }
  &::after {
    bottom: 0;
    right: 0;
  }

  span {
    left: -27px;
    top: 31px;
    transform: rotate(45deg);
  }
`;

export const ResultInfo = styled.div`
  width: 100%;

  display: flex;
  align-items: flex-start;
  flex-direction: column;

  text-align: left;

  h3 {
    font-size: 20px;
    margin-top: 15px;

    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  p {
    margin-top: 10px;
    margin-bottom: 10px;

    font-size: 17px;
  }
`;

export const CategoryImages = styled.div`
  display: flex;
  align-items: center;

  img {
    margin-right: 10px;
    filter: invert(38%) sepia(14%) saturate(5930%) hue-rotate(314deg)
      brightness(104%) contrast(97%);
  }
`;

export const ArrowContainer = styled.div`
  width: 100%;

  display: flex;
  justify-content: flex-end;
`;
